<!-- @if(totalSum !== 0){ -->
    <div class="chart-background">
        <div class="container">
            @if(totalSum === 0){
                <div class="container pt-2">
                    <p class="fs-15 fw-sbold px-1 mt-2 mt-xl-3">Ganancias <br><span class="text-header"></span></p>
                    <div class="d-flex align-items-center justify-content-center px-lg-5 py-lg-5rem pt-3 ps-5 pb-5 pe-5 bg-white rounded-4">
                        <h5 class="fw-sbold text-center lh-base mb-0">¡Aquí podrás ver tus rendimientos generados!</h5>
                    </div>
                </div>
            }
            @else {
                <div class="container-chart mb-4 mb-xl-0">
                    <div class="graph py-3 px-3 px-xl-2">
                        <p class="fs-15 fw-sbold px-1 mt-2 mt-xl-3">Ganancias <br><span class="text-header"></span></p>
                        <div class="d-flex align-items-center justify-content-center">
                            <div class="chart my-auto mt-2 p-3">
                                <div class="header-chart d-flex justify-content-between">
                                    <p class="fs-15">Has ganado</p>
                                    <p class="fw-bold fs-24" [countUp]="totalSum | toNumber"  [options]="{ decimalPlaces: 2, prefix: '$', duration: 1 }" [reanimateOnClick]="false"></p>
                                </div>
                                <div class="d-flex  justify-content-between align-items-center mt-3">
                                    <div class="chart-container align-content-center">
                                        <canvas id="myChart" height="90" width="90"></canvas>
                                    </div>
                                    <div class="my-auto align-content-center data-chart">
                                        <div class="d-flex direction-flex">
                                            <p class="fs-12 mb-0"> <img src="https://static.monific.com/assets/assets-app/img/referenced/circle-1.svg" alt=""> Referidos</p>
                                            <p><strong [countUp]="profitUser?.beneficio_referred | toNumber"  [options]="{ decimalPlaces: 2, prefix: '$', duration: 1 }" [reanimateOnClick]="false"></strong></p>
                                        </div>
                                        <div class="d-flex direction-flex">
                                            <p class="fs-12 mb-0">
                                                <img src="https://static.monific.com/assets/assets-app/img/referenced/circle2.svg" alt=""> Promociones
                                            </p>
                                            <p><strong [countUp]="profitUser?.beneficio_no_referred | toNumber"  [options]="{ decimalPlaces: 2, prefix: '$', duration: 1 }" [reanimateOnClick]="false"></strong></p>
                                        </div>
                                        <div class="d-flex direction-flex">
                                            <p class="fs-12 mb-0">
                                                <img src="https://static.monific.com/assets/assets-app/img/referenced/circle3.svg" alt=""> Rendimientos
                                            </p>
                                            <p><strong [countUp]="profitUser?.rendimientos | toNumber"  [options]="{ decimalPlaces: 2, prefix: '$', duration: 1 }" [reanimateOnClick]="false"></strong></p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            }
        </div>
    </div>
<!-- } -->